import {createStore} from "vuex";
import auth from "./auth";
import registers from "./registers";
import crypto from "crypto";
import axios from "axios";
import TabNavigation from "@/components/Templates/TabNavigation";
import router from '@/router'


const gApi = axios.create();

export default createStore({
  modules: {auth, registers},
  state: {
    notificationToken: '',
    searching: {
      stats: false,
      index: "", 
      handler: null,
      filters: [], 
      attributesToHighlight: []
    },
    searchingAsync: {
      stats: false,
      register: "", 
      collection: "", 
      handler: null,
      handlerLoading: null,
      filters: [],
      fieldsToSearch: [],
    },
    filterHeader: {
      open: false,
      hasFilter: false
    },
    dispatchSearchingAsync: {},
    loading: {
      stats: false,
      message: "carregando",
    },
    alerts: [],
    lastAlert: "Avisos",
    snackbar: {
      stat: false,
      text: "",
      color: "info",
      timeout: 3000,
    },
    drawer: false,
    drawerRight: false,
    drawerForm: false,
    fixNDR: false,
    demo: false,
    companies: [],
    companySelected: {},
    synchronizing: false,
    lastSync: null,
    offline: false,
    syncable: false,
    collectionStructure: null,
    algolia: null,
    protheus: null,
    integrations: [],
    reports: []
  },
  mutations: {
    setFiltering(state, payload){
      const {open, hasFilter} = payload
      state.filterHeader.open = open;
      if (hasFilter != undefined) state.filterHeader.hasFilter = hasFilter;
    },
    setSearching(state, {stats, index, handler, filters, attributesToHighlight}){
      state.searching = {stats, index, handler, filters, attributesToHighlight};
    },
    setSearchingAsync(state, {stats, register, collection, handler, handlerLoading, filters, fieldsToSearch}){
      state.searchingAsync = {stats, register, collection, handler, handlerLoading, filters, fieldsToSearch};
    },
    setDispatchSearchingAsync(state, {query, filters}){
      state.dispatchSearchingAsync = {query, filters};
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setLastSync(state, payload) {
      state.lastSync = payload;
    },
    setSynchronizing(state, payload) {
      state.synchronizing = payload;
    },
    setOffline(state, payload) {
      state.offline = payload;
    },
    setSyncable(state, payload) {
      state.syncable = payload;
    },
    pushAlert(state, payload) {
      state.alerts.push(payload);
      state.lastAlert = payload.type;
    },
    showSnackbar(state, payload) {
      state.snackbar = payload;
      state.snackbar.stat = true;
    },
    setDrawer(state, payload) {
      state.drawer = payload;
    },
    setDrawerRight(state, payload) {
      state.drawerRight = payload;
    },
    setFixNDR(state, payload) {
      state.fixNDR = payload;
    },
    setDrawerForm(state, payload) {
      state.drawerForm = payload;
    },
    setDemo(state, payload) {
      state.demo = payload;
    },
    setCollectionStructure(state, payload) {
      state.collectionStructure = payload;
    },
    setAlgolia(state, payload) {
      state.algolia = payload;
    },
    setProtheus(state, payload) {
      state.protheus = payload;
    },
    setCompanies(state, payload) {
      state.companies = payload;
    },
    setCompanySelect(state, payload) {
      state.companySelected = payload;
      this.$api.defaults.params = {
        groupCompany: payload.groupCompany,
        gpEmpresa: payload ? payload.M0_CODIGO+'0' : '',
        filial: payload? payload.M0_CODFIL : ''
      };
    },
    setIntegrations(state, payload) {
      state.integrations = payload
    },
    setReports(state, payload) {
      state.reports = payload
    }
  },
  actions: {
    setLastSync({commit}, lastSync) {
      commit('setLastSync', lastSync)
    },
    // GENERAL
    async initSystem({state, commit, dispatch}) {
      dispatch("auth/authChanged", {root: true});
    },
    // async setOffline({commit}, {isOffline}) {
    //   commit("setOffline", isOffline)
    // },
    async getConfigs({commit, dispatch}, {user}) {
      let companies = []
      
      const algolia = await dispatch('registers/getById', { collection: '_configs', id: 'algolia' }, {root: true})
      commit('setAlgolia', algolia)
      if (user.superAdmin) {
        const customers = await dispatch('registers/get', { collection: 'customers', register: 'customers', filters: [{key: 'active', operator: '==', value: true}]}, {root: true})
        companies = customers.map(c => c.id)
      } else {
        companies = user.companiesIds //Object.keys(user.companies)
      }
      let companiesGroup = {}

      await Promise.all(
        companies.map(async key => {
          const company = await dispatch('registers/getById', { collection: 'customers', register: 'customers', id: key, subCollection: 'sigamat' }, {root: true});
          if (company && company.sigamat && (user.superAdmin || (user.companies[company.id] && user.companies[company.id]['active']))) {
            let sigamatFiltered = user.superAdmin ? company.sigamat.map(s => ({...s, groupCompany: key, claims: company.configs?.claims})) :
              company.sigamat.filter(c => user.companies[key].active && user.companies[key].subsidiaries.includes(c.id)).map(s => ({...s, groupCompany: key, claims: company.configs?.claims}))
            sigamatFiltered = sigamatFiltered.map(s => ({
              ...s, 
              groupCompany: key,
              configs: company.configs,
              userRules: company.userRules,
            }))
            companiesGroup = {...companiesGroup, [company.id]: {sigamat: sigamatFiltered }}
          }
        })
      )
      commit('setCompanies', companiesGroup) 
      
      const lastCompany = await dispatch('setLastCompany', {companies: companiesGroup, user})
      commit('setCompanySelect', lastCompany);

      const collectionStructure = await dispatch('registers/getById', { collection: 'SX2', register: 'collectionStructure', id: lastCompany.M0_CODIGO, customerId: lastCompany.groupCompany }, {root: true});
      commit('setCollectionStructure', collectionStructure)
      
      dispatch('registers/observer', {collection: 'users', register: 'users', orderBy: 'displayName', filters: [{key: 'active', operator: '==', value: true}]}, {root:true})    

      await dispatch('setRouter', {user, company: lastCompany })
      return lastCompany
    },

    async setRouter({dispatch, state, commit, rootState}, { user, oldCompany = null, company = null }) {
      const superAdmin = user && (
          user.superAdmin || (
            user.companies && 
            company && 
            company.groupCompany && 
            user.companies[company.groupCompany] && 
            user.companies[company.groupCompany].admin
          )
        )
        
      if (oldCompany && oldCompany.groupCompany !== company.groupCompany) {
        commit('registers/resetRegisters', { root: true }) 
      }

      const integrations = await dispatch('registers/get', {collection: `integrations`, registers: 'integrations'}, {root: true});
      const reports = await dispatch('registers/get', {collection: `reports`, registers: 'reports'}, {root: true});

      commit('setIntegrations', integrations)
      commit('setReports', reports)

      // aproveita para subir a registers userRules
      await dispatch('registers/get', {collection: `userRules`, registers: 'userRules'}, {root: true}); 
  
      integrations.forEach(integration => {
        let {register, collection, filters = '', orderBy = '', details, externalRequest} = integration
        if (
          ( oldCompany && oldCompany.M0_CODIGO !== company.M0_CODIGO)
          ||
          (state.collectionStructure[register] && state.collectionStructure[register].filial === 'e')
        ) {
          // Reset Observers e Registers
          if (rootState.registers.observers[register]) {
            rootState.registers.observers[register].snapshots.forEach(el => {
              el()
            });
          }
          commit('registers/resetRegister', register, { root: true }) 

          try {
            if (['{', '['].some(symbol => orderBy.includes(symbol)))
              orderBy = JSON.parse(orderBy)
          } catch (e) {
            console.warn(`Error when trying to define "orderBy" in changeCompany ${integration.name}.`, e)
          }
          try {
            filters = (integration.filters) ? JSON.parse(integration.filters) : null
          } catch (e) {
            console.warn(`Error when trying to define "filters" in changeCompany ${integration.name}.`, e)
          }
          
          if (externalRequest && externalRequest.query) {
            dispatch('registers/getExternal',{
              ...externalRequest,
              register, 
              user
            })
          } else {
            // Start Observers
            dispatch('registers/observer', {
              collection, 
              register, 
              filters,
              orderBy,
              details,
              user
            }, {root: true})
          }
        }
      });

      const {generatedCrudRoutes, generatedTabsRoutes} = router.createCustomRouter({ integrations, reports, superAdmin})

      if(this.$router.hasRoute('Tabs')) this.$router.removeRoute('Tabs')

      this.$router.addRoute(
        {
          path: '/tabs/',
          name: 'Tabs',
          component: TabNavigation,
          children: [
            ...generatedTabsRoutes
          ]
        }  
      )
      
      for (const gr of generatedCrudRoutes) {
        if (this.$router.hasRoute(gr.name)) {
          this.$router.removeRoute(gr.name)
        } 
        // console.info('Adicionou a rota ' + gr.name);
        this.$router.addRoute({...gr})
      }

      // TODO ATIVAR APENAS OFFLINE
      // const basicRegisters = ['SED', 'SE4', 'SA4', 'TES']
      // for (const register of basicRegisters) {
      //   // Start Observers
      //   dispatch('registers/observer', {
      //     collection: register, 
      //     register, 
      //     filters: (register == 'TES') ? [] : [{'key': 'active', 'operator': '==', 'value': true}],
      //     limit: 9999,
      //     user
      //   }, {root: true})
      // }
    },
    async setLastCompany({commit}, {companies, user}){
      // ler do localstorage se está definido uma filial padrão para o usuário que logou
      // caso não tenha, define a filial matriz como padrão -> companies.filter(x => user.companies.includes(x.id))[0]
      // caso tenha localstorage mas não para o usuário que logou, adicionar o usuário e definir a matriz como padrão
      let storedCompanies = JSON.parse(localStorage.getItem('storedDefaultCompanies')) || []
      let defaultCompany = storedCompanies ? storedCompanies.find(sc => sc.user_id === user.uid) : null
      if (!defaultCompany || !defaultCompany.company || !defaultCompany.company.groupCompany || !companies[defaultCompany.company.groupCompany]) {
        const groupCompany = Object.keys(companies)[0]
        let company = companies && companies[groupCompany] ? companies[groupCompany]['sigamat'][0] : null

        if (defaultCompany) {
          const indexCompany = storedCompanies.findIndex(sc => sc.user_id === user.uid)
          storedCompanies[indexCompany] = {user_id: user.uid, company: {...company, groupCompany} }
        } else {
          defaultCompany = { user_id: user.uid, company: {...company, groupCompany} }
          storedCompanies.push(defaultCompany)
        }
        localStorage.setItem('storedDefaultCompanies', JSON.stringify(storedCompanies))
      } else { //atualize os dados da company selecionada
        const { groupCompany } = defaultCompany.company
        const defaultCompanyUpdated = companies[groupCompany].sigamat.find(s => s.id === defaultCompany.company.id)
        if (defaultCompanyUpdated) {
          const indexCompany = storedCompanies.findIndex(sc => sc.user_id === user.uid)
          defaultCompany = {user_id: user.uid, company: {...defaultCompanyUpdated, groupCompany} }
          storedCompanies[indexCompany] = defaultCompany
        } else { // caso não exista mais a company
          let company = companies && companies[groupCompany] ? companies[groupCompany]['sigamat'][0] : null
          defaultCompany = { user_id: user.uid, company: {...company, groupCompany} }
          storedCompanies.push(defaultCompany)
        }
        localStorage.setItem('storedDefaultCompanies', JSON.stringify(storedCompanies))
      }
      
      return defaultCompany.company
    },
    async changeCompany({state, commit, dispatch}, {$router, company}) {
      
      const oldCompany = this.$_.cloneDeep(state.companySelected)
      if (oldCompany && (oldCompany.groupCompany !== company.groupCompany || oldCompany.id !== company.id)) {
        $router.push('/')
        document.location.reload()
      }

      const storedCompanies = JSON.parse(localStorage.getItem('storedDefaultCompanies'))
      const user = state.auth.user
      const storedCompany = storedCompanies.find(companyWithUser => companyWithUser.user_id === user.uid)

      storedCompany.company = company
      localStorage.setItem("storedDefaultCompanies", JSON.stringify(storedCompanies))  

      commit('setCompanySelect', company)
  
      // Update User
      await dispatch('auth/updateUser', {}, {root:true})
      
      // await dispatch('setRouter', {user, $router, oldCompany, company})

      if (!$router) {
        // console.trace('traceRouter')
      }
      
      // if ($router.history.current.path.includes('/cadastrar')) $router.push($router.history.current.path.replace('/cadastrar', '/listar'))
    },
    dispatchAction({dispatch}, {action, params}) {
      dispatch(action, params, {root: true});
    },
    notify({}, {title, body, image, badge, icon, toast = true}) {
      this.$notification.show(
        title,
        {
          lang: "PT",
          body,
          image,
          badge,
          icon,
        },
        {}
      );
      if (toast) {
        this.$toast.info(`${title} - ${body}`);
      }
    },
    gravatarUrl({}, {email}) {
      let hash = crypto
        .createHash("md5")
        .update('andrewillams@gmail.com' || "")
        .digest("hex");
      return `https://www.gravatar.com/avatar/${hash}?s=200&d=mm&r=g`;
    },
    downloadFileByUrl({}, {url, type, label}) {
      gApi
        .get(url, {responseType: "blob"})
        .then((response) => {
          const blob = new Blob([response.data], {type: response.data.type});
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = label;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((e) => console.error(e));
    },
    toggleFiltering({commit}, payload){
      commit('setFiltering', payload);
    },
    toggleSearching({commit}, {stats, index, handler, filters, attributesToHighlight}){
      commit('setSearching', {stats, index, handler, filters, attributesToHighlight});
    },
    toggleSearchingAsync({commit}, {stats, register, collection, handler, handlerLoading, filters, fieldsToSearch}){
      commit('setSearchingAsync', {stats, register, collection, handler, handlerLoading, filters, fieldsToSearch});
    },
    dispatchSearchingAsync({commit}, {query, filters}){
      commit('setDispatchSearchingAsync', {query, filters});
    },
  },
});